import React from "react";
import {Field} from "formik";
import {Form, FormGroup} from "react-bootstrap";

const CheckBoxInput = ({value, shouldShowError, onChange, children, checked, ...props}) => {
    return (
        <label>
            <Field type="checkbox" name={props.id || props.name} value={value}>
                {({field, meta,}) => (
                    <FormGroup controlId={props.id || props.name} className={"mb-0"}>
                        <Form.Check>
                            <Form.Check.Input {...field} onChange={onChange || field.onChange} checked={checked}/>
                            <Form.Check.Label>
                                {children}
                            </Form.Check.Label>
                        </Form.Check>
                        {shouldShowError && (meta.touched && meta.error) && (
                            <div className="text-danger">{meta.error}</div>
                        )}
                    </FormGroup>
                )}
            </Field>
        </label>
    );
};

export default CheckBoxInput;